import { useState, useEffect } from "react";
import { $host } from "../../../../http";

const CreateThemeModal = ({ isOpen, onClose, onThemeCreated }) => {
    const [step, setStep] = useState(1);
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [paragraphs, setParagraphs] = useState([]);
    const [selectedParagraph, setSelectedParagraph] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (isOpen) {
            fetchCourses();
            setStep(1);
        }
    }, [isOpen]);

    const fetchCourses = async () => {
        try {
            const response = await $host.get("/api/teachers/courses", { withCredentials: true });
            setCourses(response.data || []);
        } catch (err) {
            setError(err.response?.data?.message || "Ошибка загрузки курсов");
        }
    };

    const fetchParagraphs = async (courseId) => {
        try {
            const response = await $host.get(`/api/teachers/paragraphs?course_id=${courseId}`, { withCredentials: true });
            setParagraphs(response.data || []);
        } catch (err) {
            setError(err.response?.data?.message || "Ошибка загрузки параграфов");
        }
    };

    const handleCourseSelect = (course) => {
        setSelectedCourse(course);
        setParagraphs([]);
        setSelectedParagraph(null);
        fetchParagraphs(course.id);
        setStep(2);
    };

    const handleParagraphSelect = (paragraph) => {
        setSelectedParagraph(paragraph);
        setStep(3);
    };

    const handleCreateTheme = async () => {
        if (!title.trim() || !description.trim() || !selectedParagraph) return;
        setLoading(true);

        try {
            const response = await $host.post(`/api/teachers/themes/create/${selectedParagraph.id}`, {
                title,
                description
            }, { withCredentials: true });

            onThemeCreated(response.data); // Передаём созданную тему
            onClose();
        } catch (error) {
            console.error("Ошибка создания темы:", error.response?.data?.message || error.message);
        }
        setLoading(false);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-xl w-[500px] relative">
                <h2 className="text-xl font-bold mb-4">
                    {step === 1 ? "Выберите курс" : step === 2 ? "Выберите параграф" : "Создайте тему"}
                </h2>

                {error && <p className="text-red-500">{error}</p>}

                {step === 1 && (
                    <div className="space-y-2">
                        {courses.map((course) => (
                            <button
                                key={course.id}
                                onClick={() => handleCourseSelect(course)}
                                className="block w-full p-2 border rounded-md text-left hover:bg-gray-100"
                            >
                                {course.title}
                            </button>
                        ))}
                    </div>
                )}

                {step === 2 && (
                    <div className="space-y-2">
                        {paragraphs.map((paragraph) => (
                            <button
                                key={paragraph.id}
                                onClick={() => handleParagraphSelect(paragraph)}
                                className="block w-full p-2 border rounded-md text-left hover:bg-gray-100"
                            >
                                {paragraph.title}
                            </button>
                        ))}
                    </div>
                )}

                {step === 3 && (
                    <div>
                        <div className="mb-4">
                            <label className="block text-sm font-medium">Название темы</label>
                            <input
                                type="text"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                className="mt-1 p-2 w-full border rounded-md"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-sm font-medium">Описание</label>
                            <textarea
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                className="mt-1 p-2 w-full border rounded-md"
                            />
                        </div>
                    </div>
                )}

                <div className="flex justify-between mt-4">
                    {step > 1 && (
                        <button onClick={() => setStep(step - 1)} className="px-4 py-2 bg-gray-300 rounded-md">
                            Назад
                        </button>
                    )}
                    {step === 3 ? (
                        <button
                            onClick={handleCreateTheme}
                            className="px-4 py-2 bg-blue-500 text-white rounded-md"
                            disabled={loading}
                        >
                            {loading ? "Создание..." : "Создать"}
                        </button>
                    ) : (
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-500 text-white rounded-md"
                        >
                            Отмена
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CreateThemeModal;
